import PropTypes from 'prop-types';
import dayjs from 'dayjs';

// @mui
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
// components
import ButtonAction from 'src/components/Button.js/SaveButton';
import { t } from 'i18next';
import DeviceDetail from 'src/components/DrawerSidebar/DeviceDetail';
import { useState } from 'react';
import imgDefault from '../../../image/default/groups.png';
import { glb_sv } from 'src/utils';
// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    padding: '10px',
});

// ----------------------------------------------------------------------

ShopProductCard.propTypes = {
    product: PropTypes.object,
};

export default function ShopProductCard({ setData, product, functEdit, functDelete, screenPermissions }) {
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };
    const renderProperty = (property) => {
        let str = '';
        if (property)
            for (let i = 0; i < property.length; i++) {
                if (property[i].checked)
                    if (i + 1 < property.length) {
                        str += property[i].labelDisplay + ', ';
                    } else {
                        str += property[i].labelDisplay;
                    }
            }
        return (
            <>
                {/* {str}{' '} */}
                <span
                    onClick={handleOpen}
                    style={{
                        fontStyle: 'italic',
                        textDecoration: 'underline',
                        color: '#057a6b',
                        cursor: 'pointer',
                    }}
                >
                    {t('detail')}
                </span>
            </>
        );
    };
    const renderUrlImage = () => {
        let url = '';
        if (product?.img_device || product?.pic_device)
            url = product?.img_device
                ? `${glb_sv.urlGetProductImage(product?.img_device)}`
                : `${glb_sv.urlGetProductImage(product?.pic_device)}`;
        return url;
    };
    return (
        <Card>
            <DeviceDetail device={product} open={visible} setOpen={setVisible} />
            <Box sx={{ pt: '100%', position: 'relative' }}>
                <StyledProductImg
                    onClick={() => setVisible(true)}
                    alt={glb_sv.convertMultipleLanguages(product?.device_nm)}
                    src={renderUrlImage() ? renderUrlImage() : imgDefault}
                />
            </Box>

            <Stack spacing={1} sx={{ p: 2 }}>
                <Link
                    onClick={() => setVisible(true)}
                    color="primary"
                    underline="always"
                    sx={{ fontStyle: 'italic', cursor: 'pointer' }}
                >
                    <Typography variant="subtitle1" noWrap>
                        {glb_sv.convertMultipleLanguages(product?.device_nm)}
                    </Typography>
                </Link>

                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Typography variant="subtitle1" sx={{ fontSize: '14px' }} noWrap>
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('code_DV')}:
                        </Typography>
                        &nbsp;
                        {product?.device_cd}
                    </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Typography variant="subtitle1" sx={{ fontSize: '14px' }}>
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('status')}:
                        </Typography>
                        &nbsp;
                        {product?.status_action === '0' ? t('borrowing') : t('take')}
                    </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="center">
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            '& > *': {
                                m: 0.2,
                            },
                        }}
                    >
                        {screenPermissions?.update_permission === '1' && (
                            <ButtonAction
                                onClick={() => {
                                    setData(product);
                                    functEdit();
                                }}
                                title={t('update')}
                                type="update"
                            />
                        )}
                        {screenPermissions?.delete_permission === '1' && (
                            <ButtonAction
                                type="delete"
                                title={t('delete')}
                                onClick={() => {
                                    setData(product);
                                    functDelete();
                                }}
                            />
                        )}
                    </Box>
                </Stack>
            </Stack>
        </Card>
    );
}
